import { GLOBAL_TRIGGERS, ProjectInteraction } from '../types';

export function isTriggerGlobal(interaction: ProjectInteraction): boolean {
  return GLOBAL_TRIGGERS.some((t) => t.value === interaction?.trigger?.type);
}
